import { SUPORTED_COLOUR_SCHEME_PROPS } from '../constants';
const validateColourScheme = colourScheme => {
  if (!colourScheme) return null;
  const validatedColourScheme = {};
  let hasProp = false;
  SUPORTED_COLOUR_SCHEME_PROPS.forEach(propKey => {
    if (colourScheme[propKey]) {
      hasProp = true;
      validatedColourScheme[propKey] = colourScheme[propKey];
    }
  });
  return hasProp ? validatedColourScheme : null;
};
export default validateColourScheme;
//# sourceMappingURL=validate-colour-scheme.js.map